<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :id="field.name"
        :value="computedDateFormattedMomentjs"
        :label="field.label"
        :prepend-icon="prependIcon"
        readonly
        :required="field.mandatory"
        v-bind="!field.readonly ? { 'clearable': true, ...attrs } : {}"
        :class="classes"
        :disabled="field.disabled"
        :rules="computedRules"
        v-on="on"
        @input="updateValue($event)"
      />
    </template>
    <v-date-picker
      v-if="!field.readonly"
      v-model="date"
      v-bind="getBindAttributes()"

      @change="save"
    />
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DatePicker',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    input: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => ({})
    },
    prependIcon: {
      type: String,
      default: 'mdi-calendar'
    }
  },
  data () {
    return {
      date: this.formatDate(this.value),
      menu: false
    };
  },
  computed: {
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('DD-MM-YYYY') : '';
    },
    minDateRule (value) {
      if (!value) return true;

      const valueDate = moment(value);
      const minDate = moment(this.data[this.input.min]);

      return valueDate.isSameOrAfter(minDate) || `La date doit être postérieure à ${minDate.format('DD-MM-YYYY')}`;
    },
    maxDateRule (value) {
      if (!value) return true;

      const valueDate = moment(value);
      const maxDate = moment(this.data[this.input.max]);

      return valueDate.isSameOrBefore(maxDate) || `La date doit être antérieure à ${maxDate.format('DD-MM-YYYY')}`;
    },
    computedRules () {
      const requiredRule = value => !!value || 'Ce champ est obligatoire';

      const rules = this.field.mandatory ? [requiredRule, ...this.rules] : this.rules;
      // if (this.input.min) rules = [this.minDateRule, ...rules];
      // if (this.input.max) rules = [this.maxDateRule, ...rules];

      return rules;
    }
  },
  watch: {
    value (newValue) {
      this.date = this.formatDate(newValue);
    }
  },
  methods: {
    formatDate (value) {
      return value ? moment(value).format('YYYY-MM-DD') : '';
    },
    updateValue (event) {
      this.$emit('input', event);
    },
    save (date) {
      this.$emit('input', date);
      this.menu = false;
    },
    getBindAttributes () {
      const bindAttrs = {};

      if (this.input.min) bindAttrs.min = this.formatDate(this.data[this.input.min]);
      else if (this.input.max) bindAttrs.max = this.formatDate(this.data[this.input.max]);

      return bindAttrs;
    }
  }
};
</script>
